var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 58.0101H5.28493V53.7251H22.4301V58.0101H26.7151V75.1277H22.4301V79.4126H31V40.8648H1V58.0101ZM9.57539 75.1277H18.1453V58.0101H9.57539V75.1277ZM1 75.1277V79.4126H5.28493V75.1277H1ZM39.5754 40.8428V53.7031H52.4302V57.988H56.7151V79.4126H61V53.7251H91V58.0101H95.2849V79.4347H99.5699V75.1498H103.86V79.4347H108.145V75.1498H112.43V79.4347H116.715V75.1498H121V40.8648L39.5754 40.8428ZM82.4246 58.0101V79.4347H86.7096V58.0101H82.4246ZM69.5644 58.0101V79.4347H73.8548V58.0101H69.5644ZM43.8548 58.0101V62.295H39.5754V79.4126H48.1452V57.988L43.8548 58.0101Z",
    fill: "#FFFFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnm);
export default __webpack_public_path__ + "static/media/onm.6a9d790078f78c402aba2c79c1ffc27f.svg";
export { ForwardRef as ReactComponent };